var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupeeSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 203.86 300",
    stroke: 1,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#010202;stroke-width:1px}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rupee") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21638",
    "data-name": "Group 21638"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26915",
    "data-name": "Path 26915",
    className: "cls-1",
    d: "M135.76,28.35H185L203.86,0h-185L0,28.35H32.1c32.5,0,62.5,2.5,74.51,29.7H19L.15,86.39h110c0,20.4-16.9,51.65-72.8,51.65h-27v26.5L118.74,300H167L54.85,160c46.15-2.5,89.46-28.31,95.7-73.56H185L203.86,58.1h-53.8a62.85,62.85,0,0,0-14.3-29.75Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupeeSymbol);
export default __webpack_public_path__ + "static/media/rupee-symbol.74c2d39647366a69c49ebfd29616cbec.svg";
export { ForwardRef as ReactComponent };